// src/api/quranService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchSurah = async (surahId, translation_id='2') => {
  try {
    const response = await axios.get(`${API_URL}/metadata/surah/${surahId}`, {
      params: {
        translation_id
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching surah:', error);
    throw error;
  }
};

// quranService.js
export const fetchQuranByPage = async (page='1') => {
  try {
    const response = await axios.get(`${API_URL}/metadata/surah_pages/${page}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching surah:', error);
    throw error;
  }
};


export const fetchJuz = async (juzId, translation_id = '2') => {
  try {
    const response = await axios.get(`${API_URL}/metadata/juz/${juzId}`, {
      params: { translation_id }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching juz:', error);
    throw error;
  }
};

/**
 * Reciters with recordings: [{_id, reciter_name}]
 */
export const fetchReciters = async () => {
  const response = await axios.get(`${API_URL}/metadata/audio/info`);
  return response.data;
};

/**
 * Available translations: [{_id, translator, ...}]
 */
export const fetchTranslations = async () => {
  const response = await axios.get(`${API_URL}/metadata/translation/info`);
  return response.data;
};

export const fetchAllSurahs = async () => {
  try {
    const response = await axios.get(`${API_URL}/metadata/surahs`);
    return response.data;
  } catch (error) {
    console.error('Error fetching all surahs:', error);
    throw error;
  }
};

export const fetchAudioRecitations = async (surahId) => {
  try {
    const response = await axios.get(`${API_URL}/media/audiolist/${surahId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching audio recitations:', error);
    throw new Error('Failed to fetch audio recitations');
  }
};

export const getSignedUrl = async (s3Path) => {
  try {
    const response = await axios.get(`${API_URL}/media/getSignedUrl?key=${encodeURIComponent(s3Path)}`);
    if (response.data) {
      return response.data.signedUrl;
    }

  } catch (error) {
    console.error('Error fetching audio recitations:', error);
    throw new Error('Failed to fetch audio recitations');
  }
};

export const downloadFile = async (s3Path, fileName) => {
  try {
    // Create the download URL pointing to your backend
    const downloadUrl = `${API_URL}/media/download-file?key=${encodeURIComponent(s3Path)}&filename=${encodeURIComponent(fileName || '')}`;

    // Use window.location to initiate the download
    window.location.href = downloadUrl;

    return true;
  } catch (error) {
    console.error('Error downloading file:', error);
    throw new Error('Failed to download file');
  }
};